import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import type { ContactsParams } from 'src/apis/organisation-service/types';
import { type AssignedShipperDetailsRequest } from 'src/apis/organisation-service/use-assigned-shipper-details';
import { useOptionalShipperContacts } from 'src/apis/organisation-service/use-optional-shipper-contacts';
import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

const Page = lazy(() => import('./page'));

type Props = {
  assignedShipperDetails: Successful<AssignedShipperDetailsRequest>;
};

export const ContactDetails: FC<Props> = ({ assignedShipperDetails }) => {
  const pageParams = usePageParamsFromSchema(
    getPaginationSchema({ pageSize: 5 })
  );

  const params = useMemo(
    () =>
      ({
        limit: pageParams.value.pageSize,
        offset: pageParams.value.start,
      }) satisfies ContactsParams,
    [pageParams.value]
  );

  const shipperContacts = useOptionalShipperContacts({
    assignedShipperDetails,
    params,
  });

  if (shipperContacts?.response === null) return <PageSpinner />;

  return (
    <Page
      assignedShipperDetails={assignedShipperDetails}
      shipperContacts={shipperContacts}
    />
  );
};
